// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6ebc1faf","703":"8e725145"}[chunkId] + ".chunk.js";
};